import colors from '../theme/colors';
import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      color: palette.internal.main,
    },
  },
  {
    props: { color: 'success' },
    style: {
      color: colors.success['800'],
    },
  },
  {
    props: { color: 'warning' },
    style: {
      color: colors.warning['800'],
    },
  },
  {
    props: { color: 'info' },
    style: {
      color: colors.price['700'],
    },
  },
  {
    props: { color: 'error' },
    style: {
      color: palette.error.dark,
    },
  },
];

export default variants;
